<template>
    <UBadge 
        :size="small ? 'xs' : 'sm'" 
        :color="color" 
        :label="label" 
        :variant="color === 'gray' && !soft ? 'solid': soft ? 'soft' : 'subtle'" 
        :class="{ 'py-0.5 px-1.5': small, 'py-px px-1': small && soft }"
    />
</template>

<script setup lang="ts">
const props = defineProps<{
    priority: string
    small?: boolean
    soft?: boolean
    prefix?: string
}>()

const label = computed(() => {
    return props.prefix ? `${props.prefix} P${props.priority}` : `P${props.priority}`
})

const color = computed(() => {
    switch (props.priority) {
        case '1': return 'red'
        case '2': return 'orange'
        case '3': return 'blue'
        case '4': return 'green'
        case '5': return 'gray'
    }
})
</script>